import { defaultAppConfig } from './default-app-config';

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};

export enum FeatureAppNames {
  FIVE_STARS = 'five-stars',
  DEFAULT = 'default',
}

export const appsUMD = {
  [FeatureAppNames.FIVE_STARS]: '/assets/five-stars/five-stars-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.FIVE_STARS]: '/assets/five-stars/five-stars-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};
